import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * The editor marker for a referenced resource that failed to resolve. The path goes
 * to the DOM `<MissingResourcesPanel>`, since clustered 3D labels overlap into blobs.
 * MeshInstance3D does not use it: a magenta material on its real geometry keeps the shape.
 */
import { CanvasItemGroup } from './CanvasItemGroup';
import { canvasItemFacing } from '../canvasItemFacing';
import { materialProgramInputs } from '../materialProgramInputs';
import { wireGizmoProgram } from './wireGizmoProgram';
const BOX_SIZE = [0.5, 0.5, 0.5];
// Both literal-only, so both keys are constant and the marker never remounts.
// Module scope, since the component draws one of them.
const BOX_MATERIAL = wireGizmoProgram('magenta');
const PLANE_MATERIAL = materialProgramInputs({
    props: { color: 'magenta', transparent: true, opacity: 0.6 },
    merge: [canvasItemFacing()],
});
export function MissingResourcePlaceholder({ shape, name, position, rotation, scale }) {
    return (_jsx(CanvasItemGroup, { name: name, position: position, rotation: rotation, scale: scale, children: shape === 'box' ? (_jsxs("mesh", { children: [_jsx("boxGeometry", { args: BOX_SIZE }), _jsx("meshBasicMaterial", { ...BOX_MATERIAL.props }, BOX_MATERIAL.key)] })) : (_jsxs("mesh", { children: [_jsx("planeGeometry", { args: [1, 1] }), _jsx("meshBasicMaterial", { ...PLANE_MATERIAL.props }, PLANE_MATERIAL.key)] })) }));
}
//# sourceMappingURL=MissingResourcePlaceholder.js.map